import { createSelector } from 'reselect'

export const selectLocationPreferred = createSelector(
  [state => state.location.location],
  location => location?.isPreferred,
)
